import type { PageProps } from "@/types";
import React, { FC, useRef } from "react";
import type { ContactPageProps } from "@/types/pages/contact";
import { ContactForm } from "../contact-modal";
import { ContentManager } from "../content-manager";
import { Image as PayallImage } from "../image";
import Image from "next/image";
import { useInView } from "@/hooks/reveal-in-view";

type FormInput = {
  value: string | boolean;
  errorMessage?: string;
  fieldName: string;
};

export const ContactUs: FC<PageProps<ContactPageProps>> = (props) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  const [formSuccess, setFormSuccess] = React.useState<boolean | null>(null);

  const [form, setForm] = React.useState<{
    [key: string]: FormInput;
  }>({
    name: {
      value: "",
      errorMessage: "",
      fieldName: "q7_fullName",
    },
    email: {
      value: "",
      errorMessage: "",
      fieldName: "q4_email",
    },
    phone: {
      value: "",
      fieldName: "q5_phoneNumber[full]",
    },
    companyName: {
      value: "",
      errorMessage: "",
      fieldName: "q8_company",
    },
    website: {
      value: "",
      errorMessage: "",
      fieldName: "q9_companyWebsite",
    },
    jobTitle: {
      value: "",
      errorMessage: "",
      fieldName: "q10_jobTitle",
    },
    country: {
      value: "",
      errorMessage: "",
      fieldName: "q12_country",
    },
    type: {
      value: "",
      errorMessage: "",
      fieldName: "q6_typeA",
    },
    interestedIn: {
      value: "",
      errorMessage: "",
      fieldName: "q13_imInterested",
    },
    receiveOtherCommunications: {
      value: false,
      errorMessage: "",
      fieldName: "q14_iAgree",
    },
  });

  const resetFormValues = () => {
    Object.keys(form).forEach((key) => {
      setForm((form) => ({
        ...form,
        [key]: {
          ...form[key],
          value: "",
        },
      }));
    });
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const requiredFields = [
      "name",
      "email",
      "companyName",
      "website",
      "jobTitle",
      "interestedIn",
      "receiveOtherCommunications",
    ];

    const invalidFields = requiredFields.filter((field) => {
      if (!form[field].value) {
        setForm((form) => ({
          ...form,
          [field]: {
            ...form[field],
            errorMessage: "This field is required",
          },
        }));
        return true;
      }
      return false;
    });

    // if (
    //   form.website.value &&
    //   !(form.website.value as string).toLowerCase().startsWith("http") &&
    //   !(form.website.value as string).toLowerCase().startsWith("www")
    //   // !(form.website.value as string).startsWith("http") &&
    //   // !(form.website.value as string).startsWith("www")
    // ) {
    //   setForm((form) => ({
    //     ...form,
    //     website: {
    //       ...form.website,
    //       errorMessage: "Please enter a valid URL",
    //     },
    //   }));
    //   invalidFields.push("website");
    // }

    if (invalidFields.length > 0) {
      return;
    } else {
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        formData.append(form[key].fieldName, JSON.stringify(form[key].value).replace(/"/g, ''));
      });
      try {
        const response = await fetch(
          "https://eu-submit.jotform.com/submit/231794625521054",
          {
            method: "POST",
            body: formData,
          }
        );

        if (response.ok) {
          // Handle successful submission
          console.log("Form submitted successfully");
          setFormSuccess(true);
          resetFormValues();
        } else {
          setFormSuccess(false);
          console.error("Form submission failed");
        }
      } catch (error) {
        setFormSuccess(false);
        console.error("An error occurred during form submission:", error);
      }
    }
  };
  return (
    <div className="contactPage">
      <div className="contactHero">
        <div className="wrapper">
          <div className="textCols textCols_lg" ref={ref}>
            <div
              className="textCols--label"
              style={{
                transform: isInView ? "none" : `translateY(20px)`,
                opacity: isInView ? 1 : 0,
                transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
              }}
            >
              About Us
            </div>
            <h1
              className="textCols--title"
              style={{
                transform: isInView ? "none" : `translateY(20px)`,
                opacity: isInView ? 1 : 0,
                transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
              }}
            >
              {props.data.title}
            </h1>
          </div>
        </div>
      </div>
      <div
        className="wrapper"
        style={{
          transform: isInView ? "none" : `translateY(20px)`,
          opacity: isInView ? 1 : 0,
          transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
        }}
      >
        {formSuccess === null && (
          <ContactForm
            onSubmit={handleSubmit}
            form={form}
            setForm={setForm}
            className="contactPage--form"
          />
        )}
        {formSuccess === true && (
          <div className="contactModal--success">
            Thank You!
            <br />
            <br />
            Your submission has been received.
          </div>
        )}
        {formSuccess === false && (
          <div className="contactModal--error">
            There was an error, please try again later.
          </div>
        )}
      </div>
      <div className="contactPage--map">
        <div className="contactPage--map-inner">
          <div className="wrapper wrapper_lg">
            <ContentManager
              content={props.data.info}
              className="contactPage--map-info"
            />
            {props.data.map.file?.url && (
              <PayallImage
                src={props.data.map as any}
                alt={props.data.map.title}
                className="contactPage--map-img"
              />
            )}
          </div>
          <Image
            src="/images/spiral-2.webp"
            alt="Spiral"
            width={1195}
            height={1467}
            draggable={false}
            className="contactPage--map-spiral"
          />
        </div>
      </div>
    </div>
  );
};
